import React from "react";
import { RobotIcon, ClockIcon, GlobeIcon } from "../Auth/onboarding/icons";
import { ChatBubbleIcon, BookIcon } from "../Dashboard/icons";
import { hostOf } from "../../utils/url";

// Not yet returned by GET /assistants/:id — shown as placeholders until the
// API exposes real counts.
const facts = [
  { icon: <ChatBubbleIcon />, label: "Conversations handled", value: "1,248" },
  { icon: <BookIcon />, label: "Knowledge sources", value: "10 connected" },
  { icon: <ClockIcon />, label: "Avg. response time", value: "3.2s" },
];

export default function AssistantProfileCard({ assistant, config }) {
  const host = hostOf(assistant?.sourceUrl);
  const isLive = assistant?.status === "ready";

  return (
    <section className="dash-card asst-profile-card">
      <div className="asst-profile-header">
        <span className="asst-profile-avatar">
          <RobotIcon />
        </span>
        <div>
          <strong>{config?.name || assistant?.name || "Assistant"}</strong>
          <span>
            {config?.tagline ||
              (host ? `AI Receptionist for ${host}` : "AI Receptionist")}
          </span>
        </div>
        {isLive && (
          <span className="dash-live-badge">
            <span className="dash-live-dot" />
            Live
          </span>
        )}
      </div>

      {assistant?.sourceUrl && (
        <a
          className="asst-profile-link"
          href={assistant.sourceUrl}
          target="_blank"
          rel="noreferrer"
        >
          <GlobeIcon />
          {host}
        </a>
      )}

      {/* <ul className="asst-fact-list">
        {facts.map((fact) => (
          <li key={fact.label}>
            <span className="asst-fact-icon">{fact.icon}</span>
            <span className="asst-fact-label">{fact.label}</span>
            <span className="asst-fact-value">{fact.value}</span>
          </li>
        ))}
      </ul> */}
    </section>
  );
}
